import { __read } from 'tslib';
import React from 'react';

/**
 *
 * @param elRef Ref object of Container that you need the height value for
 * @returns Height: number;
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useElementHeight = function (elRef) {
    var _a = __read(React.useState(0), 2), height = _a[0], setHeight = _a[1];
    var observer = React.useRef(new ResizeObserver(function (entries) {
        setHeight(entries[0].target.clientHeight);
    }));
    React.useEffect(function () {
        if (elRef.current) {
            observer.current.observe(elRef.current);
        }
        return function () {
            if (elRef.current) {
                observer.current.unobserve(elRef.current);
            }
        };
    }, [elRef, observer]);
    return height;
};

export { useElementHeight };
//# sourceMappingURL=useElementHeight.js.map
